import groq from 'groq'

export const buttonStyleFragment = groq`
  variant,
  size,
  color,
  icon,
  iconAlignment,
  isFullWidth,
  frame
`

const buttonFragment = groq`
  isButton,
  isButton == true => {
    "buttonStyles": buttonStyle {
      ${buttonStyleFragment}
    },
  },
`

export const linkPageFragment = groq`
  "id": _id,
  "type": _type,
  "slug": slug.current,
  ${buttonFragment}
`

export const linkFragment = groq`
  _key,
  _type,
  title,
  url,
  fontCase,
  ${buttonFragment}
  "page": page->{
    ${linkPageFragment}
  }
`
